// client\src\services\certificateService.js
import apiClient from '../utils/apiClient';

export const getCertificateByCourse = async (courseSlug) => {
    try {
        const response = await apiClient.get(`/certificate/course/${courseSlug}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching certificate:", error);
        return { success: false, message: "Failed to fetch certificate", data: null };
    }
};

export const getUserCertificates = async () => {
    try {
        const response = await apiClient.get(`/certificate`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user certificates:", error);
        return { success: false, message: "Failed to fetch user certificates", data: null };
    }
};

export const verifyCertificate = async (certificateId) => {
    try {
        const response = await apiClient.get(`/certificate/verify/${certificateId}`);
        return response.data;
    } catch (error) {
        console.error("Error verifying certificate:", error);
        return { success: false, message: "Certificate verification failed", data: null };
    }
};
